import { STORAGE } from '@/services';
import createPersistedState from 'vuex-persistedstate';


export default createPersistedState({
  key: STORAGE.APP.key,
  paths: [
    `app.user`,
  ],
  storage: {
    getItem: (key) => key==STORAGE.APP.key ? STORAGE.APP.get() : '',
    setItem: (key, value) => key==STORAGE.APP.key ? STORAGE.APP.set(value) : '',
    removeItem: (key) => key==STORAGE.APP.key ? STORAGE.APP.remove() : '',
  }
});